module.exports = __webpack_public_path__ + "img/logo.f099dd0e.png";